(function () {
  'use strict';

  var _designUrl = null;
  var productRoot = document.querySelector('.hj-tee-product');
  var scopeRoot = document.querySelector('.hj-personalize-scope');
  var designPropertyKey = scopeRoot && scopeRoot.dataset.designPropertyKey ? scopeRoot.dataset.designPropertyKey : '_your_design';
  var shirtColorEnabled = !!(scopeRoot && scopeRoot.dataset.shirtColorEnabled === 'true');
  var isTeeBundleBuilder = !!document.querySelector('[data-tee-bundle-builder="true"]');
  var isTeeMultiPhoto = !!document.querySelector('[data-tee-multi-photo="true"]');
  var isSameDesignSizeOffer = !!(scopeRoot && scopeRoot.dataset.sameDesignSizeOffer === 'true');
  var forcedBundleHandles = { 'proud-father-dass-tshirt': true };
  var bundleSlots = [];
  var nextSlotId = 1;
  var nextSameSizeLineId = 1;
  var recentGeneratedPosition = null;
  var bundlePickerLoaded = false;
  var bundlePickerLoading = false;

  function formatMoney(cents) {
    return '$' + (Math.max(0, cents) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function normalizePrice(value) {
    if (typeof value === 'number') return value;
    var raw = String(value || '0').replace(/[^0-9.]/g, '');
    if (!raw) return 0;
    return raw.indexOf('.') >= 0 ? Math.round(parseFloat(raw) * 100) : parseInt(raw, 10);
  }

  function parseJson(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent || el.innerHTML || '{}'); }
    catch (err) { return fallback; }
  }

  function initCutoffTimers() {
    document.querySelectorAll('[data-hj-tee-cutoff]').forEach(function (root) {
      if (root.dataset.cutoffInitialized === 'true') return;
      root.dataset.cutoffInitialized = 'true';

      var deadline = new Date(root.dataset.deadline || '');
      var daysEl = root.querySelector('[data-hj-cutoff-days]');
      var hoursEl = root.querySelector('[data-hj-cutoff-hours]');
      var minutesEl = root.querySelector('[data-hj-cutoff-minutes]');
      var secondsEl = root.querySelector('[data-hj-cutoff-seconds]');

      function pad(value) {
        return String(Math.max(0, value)).padStart(2, '0');
      }

      function render() {
        var diff = Number.isNaN(deadline.getTime()) ? 0 : Math.max(0, deadline.getTime() - Date.now());
        var secondsTotal = Math.floor(diff / 1000);
        var days = Math.floor(secondsTotal / 86400);
        var hours = Math.floor((secondsTotal % 86400) / 3600);
        var minutes = Math.floor((secondsTotal % 3600) / 60);
        var seconds = secondsTotal % 60;

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      render();
      window.setInterval(render, 1000);
    });
  }

  var productJson = parseJson('product-variants-data', {});
  var bundleData = parseJson('tee-bundle-products-data', { products: {} });
  var bundleProducts = bundleData.products || {};

  if (productJson && forcedBundleHandles[productJson.handle]) {
    isTeeBundleBuilder = true;
  }

  if (productJson && productJson.handle && !bundleProducts[productJson.handle]) {
    bundleProducts[productJson.handle] = {
      title: productJson.title,
      handle: productJson.handle,
      image: productJson.featured_image,
      variants: productJson.variants || []
    };
  }

  function ensureForcedBundleMarkup() {
    if (!isTeeBundleBuilder || !productRoot || productRoot.querySelector('[data-tee-set-builder]')) return;

    var scope = document.querySelector('.hj-personalize-scope');
    if (scope) {
      scope.setAttribute('data-tee-bundle-builder', 'true');
      scope.setAttribute('data-tee-bundle-enabled', 'true');
      if (productJson && productJson.handle) scope.setAttribute('data-tee-product-handle', productJson.handle);
    }

    var oldBundle = productRoot.querySelector('[data-multi-size-card]');
    var discountPct = oldBundle ? oldBundle.dataset.bundlePct || '15' : '15';
    var insertBefore = oldBundle;
    if (oldBundle) oldBundle.remove();

    var builder = document.createElement('div');
    builder.className = 'hj-tee-set';
    builder.setAttribute('data-show-when', 'after-gen');
    builder.setAttribute('data-tee-set-builder', '');
    builder.dataset.discountPct = discountPct;
    builder.dataset.emptyTitle = 'Add a 2nd tee - save [amount]';
    builder.dataset.emptySubtitle = '2 tees unlock ' + discountPct + '% off.';
    builder.innerHTML =
      '<div class="hj-tee-set__empty" data-tee-set-empty>' +
        '<h3 class="hj-tee-set__empty-title h4">Add a 2nd tee - <em>save ' + formatMoney(0) + '</em></h3>' +
        '<div class="hj-tee-set__empty-copywrap">' +
          '<p class="hj-tee-set__empty-copy caption-small">2 tees unlock ' + discountPct + '% off.</p>' +
          '<button type="button" class="hj-tee-set__choose" data-action="open-tee-bundle-picker">CHOOSE 2ND DESIGN</button>' +
          '<div class="hj-tee-set__locked caption-small">' +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>' +
            'Bundle price shown after preview' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="hj-tee-set__builder" data-tee-set-ready hidden>' +
        '<div class="hj-tee-set__cards" data-tee-set-cards></div>' +
        '<div class="hj-tee-set__dots" data-tee-set-dots hidden></div>' +
        '<button type="button" class="hj-tee-set__add-more caption-small" data-action="open-tee-bundle-picker">+ ADD ANOTHER DESIGN</button>' +
      '</div>' +
      '<template data-tee-set-card-template>' +
        '<article class="hj-tee-set-card" data-tee-set-card>' +
          '<div class="hj-tee-set-card__label" data-slot-label></div>' +
          '<button type="button" class="hj-tee-set-card__remove" data-slot-remove aria-label="Remove design"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
          '<div class="hj-tee-set-card__media"><img src="" alt="" loading="lazy" width="320" height="320" data-slot-image><button type="button" class="hj-tee-set-card__edit upload-trigger" data-slot-edit aria-label="Edit design"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg><span>EDIT</span></button></div>' +
          '<div class="combo hj-size-combo hj-size-combo--set" data-slot-size-combo><button type="button" class="combo-trigger hj-size-combo__trigger"><span class="combo-label" data-slot-size-label>S</span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg></button><ul class="combo-options hj-size-combo__options" data-slot-size-options></ul><input type="hidden" class="combo-input" data-slot-size value="S"></div>' +
          '<div class="hj-tee-set-card__price" data-slot-price-wrap><span class="hj-tee-set-card__price-now" data-slot-price></span><s class="hj-tee-set-card__price-old" data-slot-original-price hidden></s></div>' +
        '</article>' +
      '</template>';

    var target = productRoot.querySelector('#bundle-options') || productRoot;
    if (insertBefore && insertBefore.parentNode) insertBefore.parentNode.insertBefore(builder, insertBefore);
    else target.appendChild(builder);

    if (!document.querySelector('[data-tee-set-picker]')) {
      var picker = document.createElement('div');
      picker.className = 'hj-tee-set-picker';
      picker.setAttribute('data-tee-set-picker', '');
      picker.hidden = true;
      picker.innerHTML =
        '<button type="button" class="hj-tee-set-picker__overlay" data-action="close-tee-bundle-picker" aria-label="Close design picker"></button>' +
        '<div class="hj-tee-set-picker__panel" role="dialog" aria-modal="true" aria-labelledby="tee-set-picker-title">' +
          '<div class="hj-tee-set-picker__head"><h2 id="tee-set-picker-title">Choose another design</h2><button type="button" class="hj-tee-set-picker__close" data-action="close-tee-bundle-picker" aria-label="Close">&times;</button></div>' +
          '<div class="hj-tee-set-picker__grid" data-tee-set-picker-grid data-collection-handle="father-day"><p class="hj-tee-set-picker__empty">Loading designs...</p></div>' +
        '</div>';
      (scope || document.body).appendChild(picker);
    }
  }

  ensureForcedBundleMarkup();

  function getProductVariants(handle) {
    if (handle && bundleProducts[handle] && bundleProducts[handle].variants) {
      return bundleProducts[handle].variants;
    }
    return (productJson && productJson.variants) || [];
  }

  function getProductTitle(handle) {
    return (bundleProducts[handle] && bundleProducts[handle].title) || productJson.title || 'Custom tee';
  }

  function getProductImage(handle) {
    return (bundleProducts[handle] && bundleProducts[handle].image) || productJson.featured_image || '';
  }

  function variantPrice(variant) {
    return normalizePrice(variant && variant.price ? variant.price : 0);
  }

  function variantId(variant) {
    if (!variant) return null;
    var id = variant.id || variant.admin_graphql_api_id;
    if (typeof id === 'number') return id;
    var match = String(id || '').match(/(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  }

  function variantSize(variant) {
    return (variant && (variant.option1 || variant.title)) || 'S';
  }

  function normalizeBundleProduct(product) {
    if (!product || !product.handle) return null;
    var image = product.featured_image || product.image || '';
    if (image && typeof image === 'object') image = image.src || '';
    if (!image && product.images && product.images[0]) image = product.images[0].src || product.images[0];

    return {
      title: product.title,
      handle: product.handle,
      image: image || '',
      variants: (product.variants || []).map(function (variant) {
        return Object.assign({}, variant, {
          id: variant.id,
          price: normalizePrice(variant.price),
          compare_at_price: normalizePrice(variant.compare_at_price || variant.comparePrice || variant.price)
        });
      })
    };
  }

  function createPickerCard(product) {
    var normalized = normalizeBundleProduct(product);
    if (!normalized || !normalized.handle) return null;
    bundleProducts[normalized.handle] = normalized;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'hj-tee-set-picker__card';
    button.dataset.action = 'choose-tee-bundle-product';
    button.dataset.handle = normalized.handle;
    button.dataset.title = normalized.title || '';
    button.dataset.image = normalized.image || '';

    var imageMarkup = normalized.image
      ? '<img src="' + escapeHtml(normalized.image) + '" alt="' + escapeHtml(normalized.title) + '" loading="lazy" width="360" height="360">'
      : '<span class="hj-tee-set-picker__placeholder">' + escapeHtml(normalized.title) + '</span>';

    var firstVariant = normalized.variants[0];
    button.innerHTML =
      '<span class="hj-tee-set-picker__media">' + imageMarkup + '</span>' +
      '<span class="hj-tee-set-picker__title">' + escapeHtml(normalized.title) + '</span>' +
      '<span class="hj-tee-set-picker__price">' + formatMoney(variantPrice(firstVariant)) + '</span>';
    return button;
  }

  function loadBundlePickerProducts() {
    if (bundlePickerLoaded || bundlePickerLoading) return;
    var grid = document.querySelector('[data-tee-set-picker-grid]');
    var handle = grid ? grid.dataset.collectionHandle : '';
    if (!grid || !handle) return;

    bundlePickerLoading = true;
    fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        var products = data && data.products ? data.products : [];
        products.forEach(function (product) {
          if (!product || !product.handle) return;
          var existingCard = Array.prototype.find.call(grid.querySelectorAll('[data-action="choose-tee-bundle-product"]'), function (card) {
            return card.dataset.handle === product.handle;
          });
          if (existingCard) {
            var existing = normalizeBundleProduct(product);
            if (existing) bundleProducts[existing.handle] = existing;
            return;
          }
          var card = createPickerCard(product);
          if (card) grid.appendChild(card);
        });
        var empty = grid.querySelector('.hj-tee-set-picker__empty');
        if (empty && grid.querySelector('[data-action="choose-tee-bundle-product"]')) empty.remove();
        bundlePickerLoaded = true;
      })
      .catch(function (error) {
        console.warn('HJ: bundle picker products load failed', error);
      })
      .finally(function () {
        bundlePickerLoading = false;
      });
  }

  function findVariantBySize(size, handle) {
    var variants = getProductVariants(handle);
    return variants.find(function (v) {
      return (v.title === size || v.option1 === size) && v.available !== false;
    }) || variants.find(function (v) {
      return v.title === size || v.option1 === size;
    }) || variants.find(function (v) {
      return v.available !== false;
    }) || variants[0];
  }

  function getDefaultSize(handle) {
    return variantSize(getProductVariants(handle)[0]);
  }

  function getMainSize() {
    var input = document.querySelector('[data-tee1-size]');
    return input ? input.value : getDefaultSize(productJson.handle);
  }

  function getMainQty() {
    var qtyEl = document.querySelector('[data-tee1-qty]');
    return qtyEl ? Math.max(1, parseInt(qtyEl.value || '1', 10)) : 1;
  }

  function getSecondTeeAddonLine(readySlots, mainSlot) {
    if (!shirtColorEnabled || !productRoot) return null;
    if (isTeeBundleBuilder && readySlots && readySlots.length >= 2) return null;
    var checkbox = productRoot.querySelector('[data-second-tee-enabled]');
    if (!checkbox || !checkbox.checked) return null;

    var sizeInput = productRoot.querySelector('[data-second-tee-size]');
    var size = sizeInput && sizeInput.value ? sizeInput.value : getMainSize();
    var variant = findVariantBySize(size, productJson.handle);
    if (!variant) return null;

    var designUrl = (mainSlot && mainSlot.designUrl) || _designUrl;
    if (!designUrl) return null;

    return {
      slot: mainSlot || null,
      lineType: 'second-addon',
      variantId: variantId(variant),
      size: variantSize(variant),
      quantity: 1,
      qty: 1,
      price: variantPrice(variant),
      designUrl: designUrl,
      shirtColor: getSecondTeeColor()
    };
  }

  function syncSlotVariant(slot) {
    var variant = findVariantBySize(slot.size, slot.handle);
    if (!variant) return slot;
    slot.variantId = variantId(variant);
    slot.price = variantPrice(variant);
    slot.size = variantSize(variant);
    if (!Array.isArray(slot.sameSizeLines)) slot.sameSizeLines = [];
    return slot;
  }

  function ensureMainSlot() {
    if (!isTeeBundleBuilder || !productRoot) return null;
    if (!bundleSlots.length) {
      var handle = productJson.handle;
      bundleSlots.push(syncSlotVariant({
        slotId: nextSlotId++,
        position: 1,
        handle: handle,
        title: getProductTitle(handle),
        image: getProductImage(handle),
        designUrl: null,
        ready: false,
        size: getMainSize(),
        quantity: 1,
        isMain: true,
        sameSizeLines: []
      }));
    }
    if (!Array.isArray(bundleSlots[0].sameSizeLines)) bundleSlots[0].sameSizeLines = [];
    return bundleSlots[0];
  }

  function getSlotByPosition(pos) {
    return bundleSlots.find(function (slot) { return slot.position === pos; });
  }

  function getReadySlots() {
    ensureMainSlot();
    return bundleSlots.filter(function (slot) { return slot.ready && slot.designUrl; });
  }

  function getDiscountRate() {
    var builder = document.querySelector('[data-tee-set-builder]');
    return builder ? (parseInt(builder.dataset.discountPct || '15', 10) / 100) : 0.15;
  }

  function getDiscountPct() {
    return Math.round(getDiscountRate() * 100);
  }

  function getLegacyQuantityDiscountRate(qty) {
    if (qty >= 3) return 0.20;
    if (qty >= 2) return getDiscountRate();
    return 0;
  }

  function syncSameSizeLine(slot, line) {
    if (!slot || !line) return line;
    var variant = findVariantBySize(line.size, slot.handle);
    if (!variant) return line;
    line.variantId = variantId(variant);
    line.price = variantPrice(variant);
    line.size = variantSize(variant);
    line.quantity = Math.max(1, parseInt(line.quantity || '1', 10));
    return line;
  }

  function getSlotById(slotId) {
    ensureMainSlot();
    if (slotId === 'main') return bundleSlots[0];
    return bundleSlots.find(function (slot) { return String(slot.slotId) === String(slotId); });
  }

  function getNextSameSize(slot, preferredSize) {
    if (!slot) return '';
    var variants = getProductVariants(slot.handle);
    var used = [slot.size].concat((slot.sameSizeLines || []).map(function (line) { return line.size; }));
    var preferred = preferredSize && findVariantBySize(preferredSize, slot.handle);
    if (preferred && used.indexOf(variantSize(preferred)) === -1) return variantSize(preferred);
    var next = variants.find(function (variant) {
      return used.indexOf(variantSize(variant)) === -1 && variant.available !== false;
    }) || variants.find(function (variant) {
      return used.indexOf(variantSize(variant)) === -1;
    }) || variants.find(function (variant) {
      return variant.available !== false;
    }) || variants[0];
    return next ? variantSize(next) : slot.size;
  }

  function getDraftSameSize(slot, preferredSize) {
    if (!slot) return '';
    var preferred = preferredSize && findVariantBySize(preferredSize, slot.handle);
    if (preferred) return variantSize(preferred);
    var sVariant = findVariantBySize('S', slot.handle);
    if (sVariant) return variantSize(sVariant);
    var first = getProductVariants(slot.handle)[0];
    return first ? variantSize(first) : 'S';
  }

  function addSameSizeLine(slot, size) {
    if (!slot) return null;
    if (!Array.isArray(slot.sameSizeLines)) slot.sameSizeLines = [];
    var line = syncSameSizeLine(slot, {
      lineId: nextSameSizeLineId++,
      size: getNextSameSize(slot, size),
      quantity: 1
    });
    slot.sameSizeLines.push(line);
    return line;
  }

  function removeSameSizeLine(slot, lineId) {
    if (!slot || !Array.isArray(slot.sameSizeLines)) return;
    slot.sameSizeLines = slot.sameSizeLines.filter(function (line) {
      return String(line.lineId) !== String(lineId);
    });
  }

  function getAllTeePurchaseLines() {
    var lines = [];
    var ready = getReadySlots();
    var main = ensureMainSlot();
    var hasMultiDesign = ready.length >= 2;

    if (main) {
      if (!hasMultiDesign) main.size = getMainSize();
      main.quantity = hasMultiDesign ? Math.max(1, parseInt(main.quantity || '1', 10)) : getMainQty();
      syncSlotVariant(main);
    }

    ready.forEach(function (slot) {
      if (!Array.isArray(slot.sameSizeLines)) slot.sameSizeLines = [];
      if (!slot.isMain) {
        slot.quantity = Math.max(1, parseInt(slot.quantity || '1', 10));
        syncSlotVariant(slot);
      }
      lines.push({
        slot: slot,
        lineType: 'slot',
        slotId: slot.slotId,
        variantId: slot.variantId,
        size: slot.size,
        quantity: Math.max(1, parseInt(slot.quantity || '1', 10)),
        price: slot.price || 0,
        designUrl: slot.designUrl,
        shirtColor: getSelectedShirtColor()
      });
      slot.sameSizeLines.forEach(function (line) {
        syncSameSizeLine(slot, line);
        lines.push({
          slot: slot,
          line: line,
          lineType: 'same-size',
          slotId: slot.slotId,
          lineId: line.lineId,
          variantId: line.variantId,
          size: line.size,
          quantity: Math.max(1, parseInt(line.quantity || '1', 10)),
          price: line.price || slot.price || 0,
          designUrl: slot.designUrl,
          shirtColor: getSelectedShirtColor()
        });
      });
    });

    if (!ready.length && main) {
      lines.push({
        slot: main,
        lineType: 'slot',
        slotId: main.slotId,
        variantId: main.variantId,
        size: main.size,
        quantity: Math.max(1, parseInt(main.quantity || '1', 10)),
        price: main.price || 0,
        designUrl: main.designUrl,
        shirtColor: getSelectedShirtColor()
      });
    }

    var secondTeeAddonLine = getSecondTeeAddonLine(ready, main);
    if (secondTeeAddonLine) lines.push(secondTeeAddonLine);

    return lines;
  }

  function getBundlePricing() {
    var ready = getReadySlots();
    var lines = getAllTeePurchaseLines();
    var totalQty = lines.reduce(function (sum, line) { return sum + line.quantity; }, 0);
    var subtotal = lines.reduce(function (sum, line) { return sum + line.price * line.quantity; }, 0);
    var discountRate = getLegacyQuantityDiscountRate(totalQty);
    var savings = Math.round(subtotal * discountRate);
    return {
      slots: ready,
      lines: lines,
      totalQty: totalQty,
      subtotal: subtotal,
      savings: savings,
      total: subtotal - savings,
      bundled: savings > 0,
      multiDesign: ready.length >= 2,
      discountRate: discountRate
    };
  }

  function getTeeLines(product) {
    var lines = [];
    var tee1El = product.querySelector('[data-price-tee1]');
    var tee1Raw = tee1El ? parseInt(tee1El.dataset.priceRaw || '0', 10) : 0;
    var size1Input = product.querySelector('[data-tee1-size]');
    var tee1QtyEl = product.querySelector('[data-tee1-qty]');
    var tee1Qty = tee1QtyEl ? Math.max(1, parseInt(tee1QtyEl.value || '1', 10)) : 1;

    lines.push({
      size: size1Input ? size1Input.value : 'S',
      qty: tee1Qty,
      price: tee1Raw,
      shirtColor: getSelectedShirtColor()
    });

    product.querySelectorAll('[data-extra-tee-row]').forEach(function (row) {
      var sizeInput = row.querySelector('[data-extra-size]');
      var qtyInput = row.querySelector('[data-extra-qty]');
      var size = sizeInput ? sizeInput.value : '';
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;
      var variant = findVariantBySize(size, productJson.handle);
      if (!variant) return;
      lines.push({
        size: size,
        qty: qty,
        price: variantPrice(variant),
        shirtColor: getSelectedShirtColor(),
        row: row
      });
    });

    var secondTeeAddonLine = getSecondTeeAddonLine([], null);
    if (secondTeeAddonLine) {
      lines.push({
        size: secondTeeAddonLine.size,
        qty: secondTeeAddonLine.quantity,
        price: secondTeeAddonLine.price,
        variantId: secondTeeAddonLine.variantId,
        shirtColor: secondTeeAddonLine.shirtColor
      });
    }

    return lines;
  }

  function getLegacyPricing(product) {
    var bundleEl = product.querySelector('.hj-tee-bundle');
    var bundlePct = bundleEl ? (parseInt(bundleEl.dataset.bundlePct || '15', 10) / 100) : 0.15;
    var bundlePct3 = bundleEl ? (parseInt(bundleEl.dataset.bundlePct3 || '20', 10) / 100) : 0.20;
    var lines = getTeeLines(product);
    var totalQty = lines.reduce(function (sum, line) { return sum + line.qty; }, 0);
    var subtotal = lines.reduce(function (sum, line) { return sum + line.price * line.qty; }, 0);
    var rate = totalQty >= 3 ? bundlePct3 : (totalQty >= 2 ? bundlePct : 0);
    var savings = Math.round(subtotal * rate);

    return {
      lines: lines,
      totalQty: totalQty,
      subtotal: subtotal,
      savings: savings,
      total: subtotal - savings
    };
  }

  function updateBnpl(product, totalCents) {
    var bnpl = product.querySelector('[data-tee-bnpl]');
    if (!bnpl) return;

    var threshold = parseInt(bnpl.dataset.bnplThreshold || '3500', 10);
    var eligible = bnpl.querySelector('[data-bnpl-eligible]');
    var ineligible = bnpl.querySelector('[data-bnpl-ineligible]');
    var installmentCount = bnpl.querySelector('#interest_num');
    var installment = bnpl.querySelector('#moneyInstallment');
    var isEligible = totalCents >= threshold;
    var payments = totalCents > 5000 ? 4 : 2;

    if (eligible) eligible.hidden = !isEligible;
    if (ineligible) ineligible.hidden = isEligible;
    if (installmentCount) installmentCount.textContent = payments;
    if (installment) installment.textContent = formatMoney(Math.round(totalCents / payments));
  }

  function updateAtcText(product) {
    var atcText = product.querySelector('[data-atc-text]');
    var atcPrice = product.querySelector('[data-atc-price]');
    var atcOriginalPrice = product.querySelector('[data-atc-original-price]');
    if (!atcText) return;

    var pricing = isTeeBundleBuilder ? getBundlePricing() : getLegacyPricing(product);
    atcText.textContent = 'ADD ' + pricing.totalQty + ' TEE' + (pricing.totalQty > 1 ? 'S' : '') + ' TO CART';
    if (atcPrice) atcPrice.textContent = formatMoney(pricing.total);
    if (atcOriginalPrice) {
      if (pricing.savings > 0 && pricing.subtotal > pricing.total) {
        atcOriginalPrice.textContent = formatMoney(pricing.subtotal);
        atcOriginalPrice.hidden = false;
      } else {
        atcOriginalPrice.hidden = true;
        atcOriginalPrice.textContent = '';
      }
    }
    updateBnpl(product, pricing.total);

    var mainSizeDisplay = product.querySelector('[data-main-size-display]');
    var mainSizeInput = product.querySelector('[data-tee1-size]');
    if (mainSizeDisplay && mainSizeInput) mainSizeDisplay.textContent = mainSizeInput.value;

    var mainQtyDisplay = product.querySelector('[data-main-qty-display]');
    var mainQtyInput = product.querySelector('[data-tee1-qty]');
    if (mainQtyDisplay && mainQtyInput) mainQtyDisplay.textContent = mainQtyInput.value;

    var savingEl = product.querySelector('[data-tee-saving]');
    if (savingEl) {
      if (product.dataset.state === 'after-gen' && pricing.savings > 0) {
        var savingText = savingEl.querySelector('[data-tee-saving-text]');
        var savingCopy = 'You save ' + formatMoney(pricing.savings);
        if (pricing.totalQty >= 3) savingCopy += ' + Free Shipping';
        if (savingText) savingText.textContent = savingCopy;
        savingEl.hidden = false;
      } else {
        savingEl.hidden = true;
        var hiddenSavingText = savingEl.querySelector('[data-tee-saving-text]');
        if (hiddenSavingText) hiddenSavingText.textContent = '';
      }
    }

    product.dataset.bundleState = pricing.bundled || product.querySelector('[data-extra-tee-row]') ? 'bundled' : 'single';
    product.dataset.teeSetActive = pricing.multiDesign ? 'true' : 'false';
    renderGlobalSameSize(pricing);
    renderBundleBuilder();
  }

  function renderSizeOptions(container, slot) {
    if (!container) return;
    container.innerHTML = '';
    getProductVariants(slot.handle).forEach(function (variant) {
      var size = variantSize(variant);
      var li = document.createElement('li');
      li.className = 'combo-option' + (size === slot.size ? ' active' : '');
      li.dataset.value = size;
      li.textContent = size;
      container.appendChild(li);
    });
  }

  function renderDraftSizeOptions(container, slot, selectedSize) {
    if (!container || !slot) return;
    container.innerHTML = '';
    getProductVariants(slot.handle).forEach(function (variant) {
      var size = variantSize(variant);
      var li = document.createElement('li');
      li.className = 'combo-option' + (size === selectedSize ? ' active' : '');
      li.dataset.value = size;
      li.textContent = size;
      container.appendChild(li);
    });
  }

  function setComboValue(combo, value) {
    if (!combo) return;
    var input = combo.querySelector('.combo-input');
    var label = combo.querySelector('.combo-label');
    if (input) input.value = value;
    if (label) label.textContent = value;
    combo.querySelectorAll('.combo-option').forEach(function (option) {
      option.classList.toggle('active', option.dataset.value === value);
    });
  }

  function renderSameSizeLines(container, slot, discountRate) {
    if (!container || !slot) return;
    var template = productRoot && productRoot.querySelector('[data-same-size-line-template]');
    container.innerHTML = '';
    (slot.sameSizeLines || []).forEach(function (line) {
      syncSameSizeLine(slot, line);
      var node = template ? template.content.firstElementChild.cloneNode(true) : document.createElement('div');
      if (!template) node.className = 'hj-tee-same-size__line';
      node.dataset.sameSizeLineId = String(line.lineId);
      node.dataset.sameSizeSlotId = String(slot.slotId);
      var size = node.querySelector('[data-same-size-line-size]');
      if (size) size.textContent = 'Size ' + line.size;
      var price = node.querySelector('[data-same-size-line-price]');
      if (price) price.textContent = formatMoney(Math.max(0, line.price - Math.round(line.price * discountRate)));
      var oldPrice = node.querySelector('[data-same-size-line-old]');
      if (oldPrice) {
        oldPrice.textContent = formatMoney(line.price);
        oldPrice.hidden = discountRate <= 0;
      }
      var qty = node.querySelector('[data-same-size-qty]');
      if (qty) qty.value = Math.max(1, parseInt(line.quantity || '1', 10));
      container.appendChild(node);
    });
  }

  function configureSameSizeDraft(root, slot) {
    if (!root || !slot) return;
    var input = root.querySelector('[data-same-size-draft-size]');
    var combo = input ? input.closest('.combo') : root.querySelector('.combo');
    var selected = getDraftSameSize(slot, slot.draftSameSize || (input ? input.value : 'S'));
    if (input) {
      input.dataset.sameSizeSlotId = String(slot.slotId);
      input.value = selected;
    }
    var add = root.querySelector('[data-action="add-same-size"]');
    if (add) add.dataset.sameSizeSlotId = String(slot.slotId);
    renderDraftSizeOptions(root.querySelector('[data-same-size-draft-options]') || (combo && combo.querySelector('.combo-options')), slot, selected);
    setComboValue(combo, selected);
  }

  function renderGlobalSameSize(pricing) {
    if (!isSameDesignSizeOffer || !productRoot) return;
    var root = productRoot.querySelector('[data-same-size-global]');
    if (!root) return;
    var main = ensureMainSlot();
    var show = productRoot.dataset.state === 'after-gen' && main && main.ready && !pricing.multiDesign;
    root.hidden = !show;
    if (!show) return;
    renderSameSizeLines(root.querySelector('[data-same-size-lines]'), main, pricing.discountRate || 0);
    configureSameSizeDraft(root, main);
    root.classList.toggle('has-lines', !!(main.sameSizeLines && main.sameSizeLines.length));
  }

  function renderBundleBuilder() {
    if (!isTeeBundleBuilder || !productRoot) return;
    var builder = productRoot.querySelector('[data-tee-set-builder]');
    if (!builder) return;

    var ready = getReadySlots();
    var empty = builder.querySelector('[data-tee-set-empty]');
    var readyWrap = builder.querySelector('[data-tee-set-ready]');
    updateBundleEmptyCopy(builder);
    if (empty) empty.hidden = ready.length >= 2;
    if (readyWrap) readyWrap.hidden = ready.length < 2;
    if (ready.length < 2) return;

    var cards = builder.querySelector('[data-tee-set-cards]');
    var template = builder.querySelector('[data-tee-set-card-template]');
    if (cards && template) {
      cards.innerHTML = '';
      var pricing = getBundlePricing();
      var unitDiscountRate = getLegacyQuantityDiscountRate(pricing.totalQty);
      ready.forEach(function (slot, index) {
        var node = template.content.firstElementChild.cloneNode(true);
        node.dataset.slotId = String(slot.slotId);
        node.dataset.position = String(slot.position);
        var label = node.querySelector('[data-slot-label]');
        if (label) label.textContent = slot.title || getProductTitle(slot.handle);
        var mainLabel = node.querySelector('[data-slot-main-label]');
        if (mainLabel) mainLabel.textContent = ordinal(index + 1) + ' tee';
        var image = node.querySelector('[data-slot-image]');
        if (image) {
          image.src = slot.designUrl;
          image.alt = slot.title;
        }
        var edit = node.querySelector('[data-slot-edit]');
        if (edit) {
          edit.dataset.position = String(slot.position);
          edit.dataset.handle = slot.handle;
          edit.dataset.defaultVariantId = String(slot.variantId || '');
          edit.dataset.defaultPrice = String(slot.price || 0);
          if (slot.ready && slot.designUrl) edit.dataset.openGenerated = 'true';
          else delete edit.dataset.openGenerated;
        }
        var remove = node.querySelector('[data-slot-remove]');
        if (remove) {
          remove.dataset.slotId = String(slot.slotId);
          remove.hidden = !!slot.isMain;
        }
        var sizeLabel = node.querySelector('[data-slot-size-label]');
        if (sizeLabel) sizeLabel.textContent = slot.size;
        var sizeInput = node.querySelector('[data-slot-size]');
        if (sizeInput) {
          sizeInput.value = slot.size;
          sizeInput.dataset.slotId = String(slot.slotId);
        }
        var qtyInput = node.querySelector('[data-slot-qty]');
        if (qtyInput) {
          qtyInput.value = Math.max(1, parseInt(slot.quantity || '1', 10));
          qtyInput.dataset.slotId = String(slot.slotId);
        }
        node.querySelectorAll('[data-slot-qty-dec],[data-slot-qty-inc]').forEach(function (button) {
          button.dataset.slotId = String(slot.slotId);
        });
        renderSizeOptions(node.querySelector('[data-slot-size-options]'), slot);
        var discountedPrice = Math.max(0, slot.price - Math.round(slot.price * unitDiscountRate));
        var price = node.querySelector('[data-slot-price]');
        if (price) price.textContent = formatMoney(discountedPrice);
        var originalPrice = node.querySelector('[data-slot-original-price]');
        if (originalPrice) {
          originalPrice.textContent = formatMoney(slot.price);
          originalPrice.hidden = discountedPrice >= slot.price;
        }
        var sameSizeCard = node.querySelector('[data-same-size-card]');
        if (sameSizeCard) {
          renderSameSizeLines(sameSizeCard.querySelector('[data-same-size-lines]'), slot, unitDiscountRate);
          configureSameSizeDraft(sameSizeCard, slot);
          sameSizeCard.classList.toggle('has-lines', !!(slot.sameSizeLines && slot.sameSizeLines.length));
        }
        cards.appendChild(node);
      });
    }

    var dots = builder.querySelector('[data-tee-set-dots]');
    if (dots) {
      dots.innerHTML = '';
      dots.hidden = true;
    }
    getBundlePricing();
  }

  function updateBundleEmptyCopy(builder) {
    var main = ensureMainSlot();
    if (!main) return;
    main.size = getMainSize();
    syncSlotVariant(main);
    var discountPct = getDiscountPct();
    var savings = Math.round((main.price || 0) * 2 * (discountPct / 100));
    var title = builder.querySelector('.hj-tee-set__empty-title');
    var copy = builder.querySelector('.hj-tee-set__empty-copy');
    if (title) title.innerHTML = 'Add a 2nd tee - <em>save ' + formatMoney(savings) + '</em>';
    if (copy) copy.textContent = '2 tees unlock ' + discountPct + '% off.';
  }

  function ordinal(num) {
    if (num === 1) return '1st';
    if (num === 2) return '2nd';
    if (num === 3) return '3rd';
    return num + 'th';
  }

  function addExtraSize(product) {
    var list = product.querySelector('[data-extra-size-list]');
    var template = product.querySelector('[data-extra-size-template]');
    if (!list || !template) return;

    var node = template.content.firstElementChild.cloneNode(true);
    var usedSizes = getTeeLines(product).map(function (line) { return line.size; });
    var firstOption = node.querySelector('.combo-option');
    var nextOption = Array.prototype.find.call(node.querySelectorAll('.combo-option'), function (option) {
      return usedSizes.indexOf(option.dataset.value) === -1;
    }) || firstOption;

    if (nextOption) {
      var value = nextOption.dataset.value;
      node.querySelectorAll('.combo-option').forEach(function (option) {
        option.classList.toggle('active', option === nextOption);
      });
      var label = node.querySelector('.combo-label');
      var input = node.querySelector('[data-extra-size]');
      if (label) label.textContent = value;
      if (input) input.value = value;
    }

    list.appendChild(node);
    updateAtcText(product);
  }

  function openBundlePicker() {
    var picker = document.querySelector('[data-tee-set-picker]');
    if (!picker) return;
    picker.hidden = false;
    loadBundlePickerProducts();
    document.documentElement.classList.add('hj-tee-set-picker-open');
  }

  function closeBundlePicker() {
    var picker = document.querySelector('[data-tee-set-picker]');
    if (!picker) return;
    picker.hidden = true;
    document.documentElement.classList.remove('hj-tee-set-picker-open');
  }

  function openPersonalizeForSlot(slot) {
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'upload-trigger';
    trigger.dataset.position = String(slot.position);
    trigger.dataset.handle = slot.handle;
    trigger.dataset.defaultVariantId = String(slot.variantId || '');
    trigger.dataset.defaultPrice = String(slot.price || 0);
    if (isTeeBundleBuilder && !isTeeMultiPhoto && !slot.isMain) {
      trigger.dataset.reuseMainUpload = 'true';
    }
    trigger.style.display = 'none';
    document.body.appendChild(trigger);
    trigger.click();
    trigger.remove();
  }

  function createBundleSlot(handle, title, image) {
    ensureMainSlot();
    var position = nextSlotId;
    var slot = syncSlotVariant({
      slotId: nextSlotId++,
      position: position,
      handle: handle,
      title: title || getProductTitle(handle),
      image: image || getProductImage(handle),
      designUrl: null,
      ready: false,
      size: getDefaultSize(handle),
      quantity: 1,
      isMain: false,
      sameSizeLines: []
    });
    bundleSlots.push(slot);
    return slot;
  }

  function applyGeneratedDesign(pos, imgSrc) {
    if (!imgSrc || !productRoot) return;
    _designUrl = imgSrc;
    productRoot.dataset.state = 'after-gen';

    var slot = isTeeBundleBuilder ? (getSlotByPosition(pos) || ensureMainSlot()) : null;
    if (slot) {
      slot.designUrl = imgSrc;
      slot.ready = true;
      if (slot.isMain) slot.size = getMainSize();
      syncSlotVariant(slot);
    }

    if (!isTeeBundleBuilder || pos === 1) {
      var galleryImg = productRoot.querySelector('.hj-tee-gallery__image');
      if (galleryImg) galleryImg.src = imgSrc;
    }

    var bundleThumb = productRoot.querySelector('[data-bundle-thumb]');
    if (bundleThumb) bundleThumb.src = imgSrc;

    var atcBtn = productRoot.querySelector('[data-atc-button]');
    if (atcBtn) atcBtn.disabled = false;

    updateAtcText(productRoot);
  }

  document.addEventListener('click', function (e) {
    var addTrigger = e.target.closest('[data-action="add-extra-size"]');
    if (addTrigger) {
      var addProduct = addTrigger.closest('.hj-tee-product');
      if (addProduct) addExtraSize(addProduct);
      return;
    }

    var removeTrigger = e.target.closest('[data-action="remove-extra-size"]');
    if (removeTrigger) {
      var removeProduct = removeTrigger.closest('.hj-tee-product');
      var row = removeTrigger.closest('[data-extra-tee-row]');
      if (row) row.remove();
      if (removeProduct) updateAtcText(removeProduct);
      return;
    }

    var addSameSize = e.target.closest('[data-action="add-same-size"]');
    if (addSameSize) {
      e.preventDefault();
      var sameProduct = addSameSize.closest('.hj-tee-product');
      var slot = getSlotById(addSameSize.dataset.sameSizeSlotId || 'main');
      var holder = addSameSize.closest('[data-same-size-global],[data-same-size-card]');
      var draft = holder ? holder.querySelector('[data-same-size-draft-size]') : null;
      if (slot) addSameSizeLine(slot, draft ? draft.value : '');
      if (sameProduct) updateAtcText(sameProduct);
      return;
    }

    var removeSameSize = e.target.closest('[data-action="remove-same-size"]');
    if (removeSameSize) {
      e.preventDefault();
      var removeSameProduct = removeSameSize.closest('.hj-tee-product');
      var sameLine = removeSameSize.closest('[data-same-size-line]');
      var removeSlot = sameLine ? getSlotById(sameLine.dataset.sameSizeSlotId) : null;
      if (removeSlot && sameLine) removeSameSizeLine(removeSlot, sameLine.dataset.sameSizeLineId);
      if (removeSameProduct) updateAtcText(removeSameProduct);
      return;
    }

    if (e.target.closest('[data-action="open-tee-bundle-picker"]')) {
      e.preventDefault();
      openBundlePicker();
      return;
    }

    if (e.target.closest('[data-action="close-tee-bundle-picker"]')) {
      e.preventDefault();
      closeBundlePicker();
      return;
    }

    var removeSlot = e.target.closest('[data-slot-remove]');
    if (removeSlot) {
      e.preventDefault();
      var slotId = String(removeSlot.dataset.slotId || '');
      bundleSlots = bundleSlots.filter(function (slot) {
        return slot.isMain || String(slot.slotId) !== slotId;
      });
      if (productRoot) updateAtcText(productRoot);
      return;
    }

    var choose = e.target.closest('[data-action="choose-tee-bundle-product"]');
    if (choose) {
      e.preventDefault();
      var slot = createBundleSlot(choose.dataset.handle, choose.dataset.title, choose.dataset.image);
      closeBundlePicker();
      openPersonalizeForSlot(slot);
      return;
    }

  });

  document.addEventListener('havjoy:personalize:complete', function (event) {
    if (!isTeeBundleBuilder || !event.detail) return;
    recentGeneratedPosition = parseInt(event.detail.position || '1', 10);
    applyGeneratedDesign(recentGeneratedPosition, event.detail.imageUrl);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-dec],[data-qty-inc],[data-extra-qty-dec],[data-extra-qty-inc],[data-same-size-qty-dec],[data-same-size-qty-inc],[data-slot-qty-dec],[data-slot-qty-inc]');
    if (!btn) return;

    var product = btn.closest('.hj-tee-product');
    if (!product) return;

    var isDec = btn.hasAttribute('data-qty-dec') || btn.hasAttribute('data-extra-qty-dec') || btn.hasAttribute('data-same-size-qty-dec') || btn.hasAttribute('data-slot-qty-dec');
    if (btn.hasAttribute('data-slot-qty-dec') || btn.hasAttribute('data-slot-qty-inc')) {
      var slot = getSlotById(btn.dataset.slotId);
      if (!slot) return;
      var slotInput = btn.closest('.hj-tee-set-card') ? btn.closest('.hj-tee-set-card').querySelector('[data-slot-qty]') : null;
      var slotVal = parseInt((slotInput && slotInput.value) || slot.quantity || '1', 10);
      slot.quantity = isDec ? Math.max(1, slotVal - 1) : slotVal + 1;
      updateAtcText(product);
      return;
    }

    var sameSizeLine = btn.closest('[data-same-size-line]');
    if (sameSizeLine) {
      var sameSlot = getSlotById(sameSizeLine.dataset.sameSizeSlotId);
      var line = sameSlot && sameSlot.sameSizeLines ? sameSlot.sameSizeLines.find(function (item) {
        return String(item.lineId) === String(sameSizeLine.dataset.sameSizeLineId);
      }) : null;
      if (!line) return;
      var sameInput = sameSizeLine.querySelector('[data-same-size-qty]');
      var sameVal = parseInt((sameInput && sameInput.value) || line.quantity || '1', 10);
      line.quantity = isDec ? Math.max(1, sameVal - 1) : sameVal + 1;
      updateAtcText(product);
      return;
    }

    var row = btn.closest('[data-extra-tee-row]');
    var input = row ? row.querySelector('[data-extra-qty]') : product.querySelector('[data-tee1-qty]');
    if (!input) return;

    var val = parseInt(input.value || '1', 10);
    input.value = isDec ? Math.max(1, val - 1) : val + 1;
    updateAtcText(product);
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-second-tee-enabled],[data-second-tee-size],[data-second-tee-color],[data-shirt-color]')) {
      var optionProduct = e.target.closest('.hj-tee-product') || productRoot;
      if (optionProduct) updateAtcText(optionProduct);
      return;
    }

    if (e.target.matches('[data-tee1-qty],[data-extra-qty]')) {
      var product = e.target.closest('.hj-tee-product');
      if (!product) return;
      e.target.value = Math.max(1, parseInt(e.target.value || '1', 10));
      updateAtcText(product);
      return;
    }

    if (e.target.matches('[data-same-size-qty]')) {
      var sameProduct = e.target.closest('.hj-tee-product');
      var sameLine = e.target.closest('[data-same-size-line]');
      var sameSlot = sameLine ? getSlotById(sameLine.dataset.sameSizeSlotId) : null;
      var line = sameSlot && sameSlot.sameSizeLines ? sameSlot.sameSizeLines.find(function (item) {
        return String(item.lineId) === String(sameLine.dataset.sameSizeLineId);
      }) : null;
      if (!line || !sameProduct) return;
      line.quantity = Math.max(1, parseInt(e.target.value || '1', 10));
      updateAtcText(sameProduct);
      return;
    }

    if (e.target.matches('[data-slot-qty]')) {
      var slotProduct = e.target.closest('.hj-tee-product');
      var slot = getSlotById(e.target.dataset.slotId);
      if (!slot || !slotProduct) return;
      slot.quantity = Math.max(1, parseInt(e.target.value || '1', 10));
      updateAtcText(slotProduct);
      return;
    }

    if (e.target.matches('[data-slot-size]')) {
      var slot = bundleSlots.find(function (item) {
        return String(item.slotId) === String(e.target.dataset.slotId);
      });
      if (!slot) return;
      slot.size = e.target.value;
      syncSlotVariant(slot);
      if (slot.isMain) {
        var mainSizeInput = productRoot && productRoot.querySelector('[data-tee1-size]');
        if (mainSizeInput) {
          mainSizeInput.value = slot.size;
          setComboValue(mainSizeInput.closest('.combo'), slot.size);
        }
      }
      updateAtcText(productRoot);
    }
  });

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.hj-tee-gallery__thumb');
    if (!thumb) return;

    var product = thumb.closest('.hj-tee-product');
    if (!product) return;

    var mainImg = product.querySelector('.hj-tee-gallery__image');
    if (mainImg && thumb.dataset.imageSrc) mainImg.src = thumb.dataset.imageSrc;

    product.querySelectorAll('.hj-tee-gallery__thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  document.addEventListener('click', function (e) {
    var option = e.target.closest('.combo-option');
    if (!option) return;
    var product = option.closest('.hj-tee-product');
    if (!product) return;

    var combo = option.closest('.combo');
    var size = option.dataset.value;
    if (!size || !combo) return;

    var isMainTee = combo.querySelector('[data-tee1-size]') !== null;
    if (isMainTee) {
      var variant = findVariantBySize(size, productJson.handle);
      var tee1El = product.querySelector('[data-price-tee1]');
      if (tee1El && variant) tee1El.dataset.priceRaw = String(variantPrice(variant));
      var mainSlot = ensureMainSlot();
      if (mainSlot) {
        mainSlot.size = size;
        syncSlotVariant(mainSlot);
      }
    }

    var slotSizeInput = combo.querySelector('[data-slot-size]');
    if (slotSizeInput) {
      var slot = bundleSlots.find(function (item) {
        return String(item.slotId) === String(slotSizeInput.dataset.slotId);
      });
      if (slot) {
        slot.size = size;
        syncSlotVariant(slot);
        if (slot.isMain) {
          var mainSizeInput = product.querySelector('[data-tee1-size]');
          if (mainSizeInput) {
            mainSizeInput.value = slot.size;
            setComboValue(mainSizeInput.closest('.combo'), slot.size);
          }
        }
      }
    }

    var draftInput = combo.querySelector('[data-same-size-draft-size]');
    if (draftInput) {
      draftInput.value = size;
      var draftSlot = getSlotById(draftInput.dataset.sameSizeSlotId || 'main');
      if (draftSlot) draftSlot.draftSameSize = size;
    }

    setTimeout(function () { updateAtcText(product); }, 0);
  });

  function initGenState() {
    var modal = document.getElementById('personalize-modal');
    if (!modal) return;

    var designActions = modal.querySelector('.hj-design-actions');
    if (designActions) {
      var genObserver = new MutationObserver(function () {
        if (modal.open && modal.dataset.teeAutoCloseOnPreview === 'true' && designActions.style.display === 'flex') {
          modal.dataset.teeAutoCloseOnPreview = '';
          modal.close();
        }
      });
      genObserver.observe(designActions, { attributes: true, attributeFilter: ['style'] });
    }

    modal.addEventListener('close', function () {
      var mainImg = modal.querySelector('.main-image');
      if (!mainImg || mainImg.style.display === 'none') return;
      var imgSrc = mainImg.src;
      if (!imgSrc || imgSrc === window.location.href) return;

      if (isTeeBundleBuilder) {
        recentGeneratedPosition = null;
        return;
      }

      var pos = parseInt(modal.dataset.position || '1', 10);
      applyGeneratedDesign(pos, imgSrc);

      var product = document.querySelector('.hj-tee-product');
      if (!product) return;

      var sizeInput = product.querySelector('[data-tee1-size]');
      if (sizeInput && !sizeInput.value) {
        sizeInput.value = 'S';
        var combo = sizeInput.closest('.combo');
        if (combo) {
          var lbl = combo.querySelector('.combo-label');
          if (lbl) lbl.textContent = 'S';
          combo.querySelectorAll('.combo-option').forEach(function (o) {
            o.classList.toggle('active', o.dataset.value === 'S');
          });
        }
      }

      updateAtcText(product);
    });

    var form = document.getElementById('tee-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var C = window.HavjoyCore;
      if (!_designUrl) {
        if (C) C.showToast('Please upload and generate your design first', 'warning');
        return;
      }

      var product = form.querySelector('.hj-tee-product');
      if (!product) return;

      var items = [];
      var atcBtn = form.querySelector('[data-atc-button]');

      if (isTeeBundleBuilder) {
        var pricing = getBundlePricing();
        pricing.lines.forEach(function (line) {
          if (!line.variantId || !line.designUrl) return;
          items.push({
            id: variantId({ id: line.variantId }),
            quantity: Math.max(1, parseInt(line.quantity || '1', 10)),
            properties: createDesignProperties(line.designUrl, line.shirtColor)
          });
        });
      } else {
        var itemsByVariant = {};
        var designForSingle = isTeeBundleBuilder ? (ensureMainSlot() && ensureMainSlot().designUrl) : _designUrl;
        function makeCartItem(variantId, quantity, shirtColor) {
          var item = { id: variantId, quantity: quantity };
          if (designForSingle) item.properties = createDesignProperties(designForSingle, shirtColor);
          return item;
        }
        function addLine(size, qty) {
          var variant = findVariantBySize(size, productJson.handle);
          if (!variant) return false;
          var key = String(variantId(variant));
          itemsByVariant[key] = (itemsByVariant[key] || 0) + qty;
          return true;
        }

        if (shirtColorEnabled) {
          getTeeLines(product).forEach(function (line) {
            var variant = line.variantId ? { id: line.variantId } : findVariantBySize(line.size, productJson.handle);
            if (!variant) return;
            items.push(makeCartItem(variantId(variant), Math.max(1, parseInt(line.qty || '1', 10)), line.shirtColor));
          });
        } else {
          getTeeLines(product).forEach(function (line) {
            addLine(line.size, line.qty);
          });

          Object.keys(itemsByVariant).forEach(function (id) {
            items.push(makeCartItem(variantId({ id: id }), itemsByVariant[id]));
          });
        }
      }

      items = items.filter(function (item) {
        return item.id && !Number.isNaN(item.id) && item.quantity > 0;
      });

      if (!items.length) {
        if (C) C.showToast('Variant not found', 'error');
        return;
      }

      if (atcBtn) atcBtn.disabled = true;

      if (C && C.submitToCart) {
        C.submitToCart(items)
          .then(function () { if (atcBtn) atcBtn.disabled = false; })
          .catch(function (error) {
            console.error('HJ tee cart add failed', error, items);
            if (C) C.showToast('Error adding to cart. Please try again.', 'error');
            if (atcBtn) atcBtn.disabled = false;
          });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { if (atcBtn) atcBtn.disabled = false; });
      }
    });
  }

  function initAtcText() {
    var product = document.querySelector('.hj-tee-product');
    if (!product) return;
    ensureMainSlot();
    updateAtcText(product);
  }

  function createDesignProperties(designUrl, shirtColor) {
    var properties = {};
    properties[designPropertyKey] = designUrl;
    if (shirtColorEnabled) properties.shirt_color = normalizeShirtColor(shirtColor || getSelectedShirtColor());
    return properties;
  }

  function getSelectedShirtColor() {
    var input = document.querySelector('[data-shirt-color]');
    return normalizeShirtColor(input ? input.value : "white (women's design)");
  }

  function getSecondTeeColor() {
    var input = document.querySelector('[data-second-tee-color]');
    return normalizeShirtColor(input ? input.value : "black ( men's design)");
  }

  function normalizeShirtColor(value) {
    var color = String(value || '').toLowerCase();
    return color.indexOf('black') === 0 ? "black ( men's design)" : "white (women's design)";
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGenState();
      initAtcText();
      initCutoffTimers();
    });
  } else {
    initGenState();
    initAtcText();
    initCutoffTimers();
  }
})();
